import { Message } from 'element-ui'
const instances = []
const newMessage = options => {
  if (instances.length <= 2) {
    instances.push(Message(options))
  } else {
    instances[0].close()
    instances.shift()
    instances.push(Message(options))
  }
}
const messageList = ['error', 'success', 'info', 'warning']
messageList.forEach(type => {
  newMessage[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }
    options.type = type
    return newMessage(options)
  }
})
export const message = newMessage
